__turbopack_context__.v({
  "scrollbar": "scroll-area-module__Hr-d8W__scrollbar",
});
